import { useState } from "react";
import "./main.css";
import Editor from "./modes/Editor";
import Game from "./modes/Game";
import { MODE } from "./types/game";

export default function Main() {
  const [mode, setMode] = useState<MODE>(MODE.EDITOR);

  return (
    <div>
      {mode === MODE.EDITOR ? (
        <Editor
          onClickPlay={() => {
            setMode(MODE.GAME);
          }}
        />
      ) : (
        <Game
          onModeToggle={() => {
            setMode(MODE.EDITOR);
          }}
        />
      )}
    </div>
  );
}
